export default "__VITE_ASSET__CgY8hT2c__"